export const genericFormatter = (strings: string[] = [], separator = ' '): string => {
  return strings.filter((s) => s).join(separator);
};
